/**
 * Data-source switch.
 *
 * The whole app talks to `src/services/api/*`. That layer reads this flag to
 * decide whether to use the in-browser mock store (default — used for demos)
 * or the real HTTP backend (FastAPI). Nothing in the UI changes either way.
 *
 * Set via a `.env` file (see `.env.example`):
 *   VITE_DATA_SOURCE=mock   → in-browser localStorage store (default)
 *   VITE_DATA_SOURCE=api    → real backend at VITE_API_URL
 */
export const DATA_SOURCE: 'mock' | 'api' =
  (import.meta.env.VITE_DATA_SOURCE as 'mock' | 'api' | undefined) ?? 'mock'

/** Base path/URL for the real backend (used only when DATA_SOURCE === 'api'). */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? '/api'

export const USING_API = DATA_SOURCE === 'api'
